import React, { useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { CJ, MI, TASS } from './../Lottie';
import * as Utils from '../../utils';
import { FRONT_COVER_ID } from '../../constants';

const Splash = ({ setIsSplashVisible, ...rest }) => {
  const [splashRef, isInView] = useInView({ threshold: 0.5 });
  const [isMIAnimationCompleted, setIsMiAnimationCompleted] = useState(false);
  const [isCjAnimationCompleted, setIsCjAnimationCompleted] = useState(false);
  const [isTassAnimationCompleted, setIsTassAnimationCompleted] = useState(false);

  useEffect(() => {
    if (isTassAnimationCompleted && isInView) {
      setIsSplashVisible(false);
      Utils.scroll(FRONT_COVER_ID);
    }
  }, [isTassAnimationCompleted, isInView]);

  return (
    <div
      className={classnames('splash', { 'd-none': isTassAnimationCompleted })}
      ref={splashRef}
      {...rest}
    >
      <div className='container'>
        <div className='row'>
          <div className='col'>
            <div className='splash__container'>
              <div className='splash__item'>
                <MI
                  eventListeners={[
                    {
                      eventName: 'complete',
                      callback: () => setIsMiAnimationCompleted(true),
                    },
                  ]}
                />
              </div>
              <div className='splash__item'>
                {isMIAnimationCompleted && (
                  <CJ
                    eventListeners={[
                      {
                        eventName: 'complete',
                        callback: () => setIsCjAnimationCompleted(true),
                      },
                    ]}
                  />
                )}
              </div>
              <div className='splash__item'>
                {isCjAnimationCompleted && (
                  <TASS
                    eventListeners={[
                      {
                        eventName: 'complete',
                        callback: () => setIsTassAnimationCompleted(true),
                      },
                    ]}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

Splash.propTypes = {
  setIsSplashVisible: PropTypes.func,
};

export default Splash;
